import { combineEpics } from 'web-app/util/redux-observable';
import employeeCheckIn from './check-in/epics';
import employeeCheckOut from './check-out/epics';
export default combineEpics(employeeCheckIn, employeeCheckOut);
